import React, { useState, useEffect, useRef } from 'react';
import { useParams } from "react-router-dom";

import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import {
    detalheFilialCentroDistribuicaoSeller,
    cadastrarFilialCentroDistribuicaoSeller,
    editarFilialCentroDistribuicaoSeller,
    inativarFilialCentroDistribuicaoSeller,
    ativarFilialCentroDistribuicaoSeller
} from '../../../../../services/http/SellerAdminstradorService/filialCdSellerService'
import { trackPromise } from 'react-promise-tracker';
import services from '../../../../../services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { estados, cidadesBrasil } from '../../../../../services/estadosBrasil'
import { tiposUnidades } from '../../../../../services/tipoUnidade';
import { buscarEnderecoPorCep } from '../../../../../services/cepService';
import { useSnackBar } from '../../../../../hooks/snackBar';

import './styles.scss';

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 48 * 4.5 + 8,
            width: 250
        }
    },
    getContentAnchorEl: null,
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
    },
    transformOrigin: {
        vertical: "top",
        horizontal: "center"
    },
    variant: "menu"
};

const FormCdSeller = ({ id, subSellerPage }) => {
    const { addSnackBar } = useSnackBar();
    const { idEmpresa } = useParams();
    const [isFormInvalid, setIsFormInvalid] = useState(false);
    const [idCdSeller, setIdCdSeller] = useState(null);
    const [voltou, setVoltou] = useState(false);
    const stateRef = useRef();
    stateRef.current = voltou;
    const [cidades, setCidades] = useState([]);
    const [centroDistribuicaoSeller, setCentroDistribuicaoSeller] = useState({
        cnpj: "",
        ie: "",
        codigo: 0,
        razaoSocial: "",
        nomeFantasia: "",
        tipo: "",
        ativo: false,
        tipoUnidade: null,
        endereco: {
            id: "",
            cep: "",
            logradouro: "",
            numero: "",
            complemento: "",
            bairro: "",
            cidade: "",
            estado: "",
            urlGoogleMaps: ""
        },
        telefone: {
            id: "",
            ddd: "",
            numero: ""
        },
        atendimentoCargaDescarga: {
            horarioAtendimento: "",
            contato: "",
            observacoes: ""
        }
    });

    useEffect(() => {
        if (id != null) {
            setIdCdSeller(id);
            CarregarDetalhescentroDistribuicaoSeller(id);
        }
        var elementAba = document.getElementById('aba-2');
        elementAba.classList.add("active");

        return () => {
            if (!stateRef.current) {
                elementAba.classList.remove("active");
            }
        }
    }, []);

    const voltar = () => {
        setVoltou(true);
        stateRef.current = true;
        subSellerPage(2);
    }

    const enderecoPorCep = (cep) => {
        trackPromise(
            buscarEnderecoPorCep(cep)
                .then(res => {
                    if (!res.fail && res.data) {
                        listarCidadesBrasil(res.data?.uf.sigla);

                        setCentroDistribuicaoSeller((prevent) => ({
                            ...prevent,
                            endereco: {
                                cep: res.data?.cep,
                                logradouro: res.data?.logradouro,
                                bairro: res.data?.bairro,
                                estado: res.data?.uf.sigla,
                                cidade: res.data?.cidade.nome
                            }
                        }))
                    }
                })
        ).catch(error => {
            console.log(error);
        })
    }

    const CarregarDetalhescentroDistribuicaoSeller = (id) => {
        trackPromise(
            detalheFilialCentroDistribuicaoSeller(id)
                .then(res => {
                    if (res.data) {
                        setCentroDistribuicaoSeller(res.data);
                        listarCidadesBrasil(res.data.endereco.estado);
                    } else {
                        if (id) {
                            addSnackBar({ message: 'Não foi possível carregar detalhes do cd', info: 'warning', open: true });
                        }
                    }
                }).catch(error => {
                    addSnackBar({ message: 'Erro ao tentar obter detalhes do cd', info: 'error', open: true });
                })
        )
    }

    const listarCidadesBrasil = (uf) => {
        trackPromise(
            cidadesBrasil(uf)
                .then(res => {
                    if (res.data) {
                        setCidades(res.data);
                    } else {
                        addSnackBar({ message: 'Não foi possível carregar as cidades', info: 'warning', open: true });
                    }
                }).catch(error => {
                    addSnackBar({ message: 'Erro ao carregar cidades', info: 'error', open: true });
                })
        )
    }

    const validarForm = () => {
        var isInvalidForm = false;
        if (!centroDistribuicaoSeller.cnpj) isInvalidForm = true;
        if (!centroDistribuicaoSeller.razaoSocial) isInvalidForm = true;
        if (!centroDistribuicaoSeller.nomeFantasia) isInvalidForm = true;
        if (centroDistribuicaoSeller.tipoUnidade == null
            || centroDistribuicaoSeller.tipoUnidade == 4
            || centroDistribuicaoSeller.tipoUnidade == undefined) isInvalidForm = true;
        /*  if (!centroDistribuicaoSeller.endereco.bairro) isInvalidForm = true;
         if (!centroDistribuicaoSeller.endereco.numero) isInvalidForm = true;
         if (!centroDistribuicaoSeller.endereco.cep) isInvalidForm = true;
         if (!centroDistribuicaoSeller.endereco.cidade) isInvalidForm = true;
         if (!centroDistribuicaoSeller.endereco.logradouro) isInvalidForm = true; */

        setIsFormInvalid(isInvalidForm);

        return isInvalidForm;
    }

    const verificarTelefone = () => {
        //if (centroDistribuicaoSeller.telefone.numero.includes("(")) {
        //    centroDistribuicaoSeller.telefone.ddd = centroDistribuicaoSeller.telefone.numero.substring(0, 4).replace("(", "").replace(")", "");
        //    centroDistribuicaoSeller.telefone.numero = centroDistribuicaoSeller.telefone.numero.substring(5, centroDistribuicaoSeller.telefone.lenght).replace('-', '');
        //}

        //if (centroDistribuicaoSeller.telefone.numero.length == 11) {
        //    centroDistribuicaoSeller.telefone.numero = centroDistribuicaoSeller.telefone.numero.substring(2, centroDistribuicaoSeller.telefone.numero.length);
        //}
    }

    const inativarCentroDistribuicao = () => {
        if (idCdSeller != undefined) {
            trackPromise(
                inativarFilialCentroDistribuicaoSeller(idCdSeller)
                    .then(res => {
                        if (res.data) {
                            addSnackBar({ message: 'Cd inativado com sucesso', info: 'success', open: true });
                            voltar(2);
                        } else {
                            addSnackBar({ message: 'Não foi possível inativar cd', info: 'warning', open: true });
                        }
                    }).catch(error => {
                        console.log(error);
                        addSnackBar({ message: 'Erro ao inativar cd', info: 'error', open: true });
                    })
            )
        }
    }

    const ativarCentroDistribuicao = () => {
        if (idCdSeller != undefined) {
            trackPromise(
                ativarFilialCentroDistribuicaoSeller(idCdSeller)
                    .then(res => {
                        if (res.data) {
                            addSnackBar({ message: 'Cd ativado com sucesso', info: 'success', open: true });
                            voltar(2);
                        } else {
                            addSnackBar({ message: 'Não foi possível ativar cd', info: 'warning', open: true });
                        }
                    }).catch(error => {
                        console.log(error);
                        addSnackBar({ message: 'Erro ao ativar cd', info: 'error', open: true });
                    })
            )
        }
    }

    const submitcentroDistribuicaoSeller = () => {
        if (!validarForm()) {
            centroDistribuicaoSeller.cnpj = services.mask.unMask(centroDistribuicaoSeller.cnpj)
            centroDistribuicaoSeller.endereco.cep = services.mask.unMask(centroDistribuicaoSeller.endereco.cep)
            verificarTelefone();

            if (idCdSeller == null || idCdSeller == undefined) {
                trackPromise(
                    cadastrarFilialCentroDistribuicaoSeller(centroDistribuicaoSeller, idEmpresa)
                        .then(res => {
                            if (res.data) {
                                addSnackBar({ message: 'Cadastrado com sucesso', info: 'success', open: true });
                                setIdCdSeller(res.data);
                                voltar(2);
                            } else {
                                res.errors.forEach(element => {
                                    addSnackBar({ message: element.menssagem, info: 'warning', open: true });
                                });

                            }
                        }).catch(error => {
                            console.log(error);
                            addSnackBar({ message: 'Erro ao cadastrar cd', info: 'error', open: true });
                        })
                )
            }
            else {
                centroDistribuicaoSeller.id = idCdSeller;
                trackPromise(
                    editarFilialCentroDistribuicaoSeller(centroDistribuicaoSeller)
                        .then(res => {
                            if (res.fail == null) {
                                addSnackBar({ message: 'Seller atualizado com sucesso', info: 'success', open: true });
                                voltar(2);
                            } else {
                                res.errors.forEach(element => {
                                    addSnackBar({ message: element.menssagem, info: 'warning', open: true });
                                });
                            }
                        }).catch(error => {
                            console.log(error);
                            addSnackBar({ message: 'Erro ao editar cd', info: 'error', open: true });
                        })
                )
            }

        }
        //if (centroDistribuicaoSeller.telefone.numero.length == 9) {
        //    centroDistribuicaoSeller.telefone.numero =  centroDistribuicaoSeller.telefone.ddd + centroDistribuicaoSeller.telefone.numero;
        //}

    }

    useEffect(() => {
        //if (centroDistribuicaoSeller.telefone.numero != "" && centroDistribuicaoSeller.telefone.numero.length == 9) {
        //    centroDistribuicaoSeller.telefone.numero = centroDistribuicaoSeller.telefone.ddd + centroDistribuicaoSeller.telefone.numero;
        //}
    }, [centroDistribuicaoSeller]);

    const changesCentroDestribuicao = (value, propertie) => {
        setCentroDistribuicaoSeller((prevent) => ({
            ...prevent,
            [propertie]: value
        }));
    }

    const changesTipoUnidade = (value, propertie) => {
        setCentroDistribuicaoSeller((prevent) => ({
            ...prevent,
            [propertie]: value
        }));
    }

    const changesEndereco = (value, propertie,) => {
        setCentroDistribuicaoSeller((prevent) => ({
            ...prevent,
            endereco: {
                ...prevent.endereco,
                [propertie]: value
            }
        }));
        //alert(value);
        if (propertie === 'estado') {
            listarCidadesBrasil(value);
        }

    }

    const changesTelefone = (value) => {
        var ddd = (value.length >= 2 ? value.substring(0, 4) : value).replace("(", "").replace(")", "");
        var numero = (value.length >= 2 ? value.substring(5, value.length) : '').replace('-', '').replace(' ', '');
        setCentroDistribuicaoSeller((prevent) => ({
            ...prevent,
            telefone: {
                ...prevent.telefone,
                numero: numero,
                ddd: ddd
            }
        }));
    }

    const changesAtendimentoCargaDescarga = (value, propertie) => {
        setCentroDistribuicaoSeller((prevent) => ({
            ...prevent,
            atendimentoCargaDescarga: {
                ...prevent.atendimentoCargaDescarga,
                [propertie]: value
            }
        }));
    }

    const showCdField = () => {
        if (idCdSeller != null || idCdSeller != undefined) {
            return (<div className="row mt-3">
                <div className="col-sm-5 col-md-5 col-lg-5">
                    <FormControl>
                        <TextField
                            label="#ID"
                            type="text"
                            size="small"
                            id="outlined-basic"
                            variant="outlined"
                            disabled={true}
                            value={"00000" + centroDistribuicaoSeller.codigo}
                        />
                    </FormControl>
                </div>
            </div>)
        }
    }

    return (
        <div className="ml-1 mt20">
            <div className="row"> <div className="col-sm-12 col-md-12 col-lg-12 font"><strong>Dados da Empresa</strong></div></div>
            {showCdField()}
            <div className="row">
                <div className="col-sm-2 col-md-2 col-lg-2">
                    <FormControl>
                        <TextField
                            required
                            label="CNPJ"
                            placeholder="00000000000000"
                            type="text"
                            size="small"
                            id="outlined-basic"
                            variant="outlined"
                            onChange={event => changesCentroDestribuicao(services.mask.cpfCnpj(event.target.value), 'cnpj')}
                            value={services.mask.cpfCnpj(centroDistribuicaoSeller?.cnpj) || ''}
                            helperText={isFormInvalid && !centroDistribuicaoSeller?.cnpj && 'Campo obrigatório'}
                            error={isFormInvalid && !centroDistribuicaoSeller?.cnpj ? true : false}
                        />
                    </FormControl>
                </div>

                <div className="col-sm-2 col-md-2 col-lg-2">
                    <FormControl>
                        <TextField
                            label="IE"
                            inputProps={{ maxLength: 20 }}
                            placeholder="000000"
                            type="text"
                            size="small"
                            id="outlined-basic"
                            variant="outlined"
                            onChange={event => changesCentroDestribuicao(event.target.value, 'ie')}
                            value={centroDistribuicaoSeller?.ie || ''}
                        /*  helperText={isFormInvalid && !centroDistribuicaoSeller?.ie && 'Campo obrigatório'}
                         error={isFormInvalid && !centroDistribuicaoSeller?.ie ? true : false} */
                        />
                    </FormControl>
                </div>

                <div className="col-sm-2 col-md-2 col-lg-2">
                    <FormControl >
                        <TextField
                            label="IM"
                            inputProps={{ maxLength: 20 }}
                            placeholder="000000"
                            type="text"
                            size="small"
                            id="outlined-basic"
                            variant="outlined"
                            onChange={event => changesCentroDestribuicao(event.target.value, 'im')}
                            value={centroDistribuicaoSeller?.im || ''}
                        /*  helperText={isFormInvalid && !centroDistribuicaoSeller?.im && 'Campo obrigatório'}
                         error={isFormInvalid && !centroDistribuicaoSeller?.im ? true : false} */
                        />
                    </FormControl>
                </div>

                <div className="col-sm-3 col-md-3 col-lg-3">
                    <FormControl >
                        <TextField
                            required
                            label="Razão Social"
                            inputProps={{ maxLength: 200 }}
                            placeholder="Informe a Razão Social"
                            type="text"
                            size="small"
                            id="outlined-basic"
                            variant="outlined"
                            onChange={event => changesCentroDestribuicao(event.target.value, 'razaoSocial')}
                            value={centroDistribuicaoSeller?.razaoSocial || ''}
                            helperText={isFormInvalid && !centroDistribuicaoSeller?.razaoSocial && 'Campo obrigatório'}
                            error={isFormInvalid && !centroDistribuicaoSeller?.razaoSocial ? true : false}
                        />
                    </FormControl>
                </div>

                <div className="col-sm-3 col-md-3 col-lg-3">
                    <FormControl>
                        <TextField
                            required
                            label="Nome Fantasia"
                            inputProps={{ maxLength: 150 }}
                            placeholder="Informe o Nome Fantasia"
                            type="text"
                            size="small"
                            id="outlined-basic"
                            variant="outlined"
                            onChange={event => changesCentroDestribuicao(event.target.value, 'nomeFantasia')}
                            value={centroDistribuicaoSeller?.nomeFantasia || ''}
                            helperText={isFormInvalid && !centroDistribuicaoSeller?.nomeFantasia && 'Campo obrigatório'}
                            error={isFormInvalid && !centroDistribuicaoSeller?.nomeFantasia ? true : false}
                        />
                    </FormControl>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-3 col-md-3 col-lg-3"><FormControl >
                    <TextField
                        /* required */
                        label="Telefone"
                        inputProps={{ maxLength: 15 }}
                        placeholder="00 00000-0000"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={event => changesTelefone(services.mask.phoneoucelularchange(event.target.value))}
                        value={services.mask.phoneoucelular(centroDistribuicaoSeller?.telefone?.ddd + centroDistribuicaoSeller?.telefone?.numero) || ''}
                    /* helperText={isFormInvalid && !centroDistribuicaoSeller?.telefone.numero && 'Campo obrigatório'}
                    error={isFormInvalid && !centroDistribuicaoSeller?.telefone.numero ? true : false} */
                    />
                </FormControl></div>
                <div className="col-sm-2 col-md-2 col-lg-2"><FormControl >
                    <TextField
                        /* required */
                        label="CEP"
                        placeholder="00000-000"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        onBlur={event => enderecoPorCep(event.target.value)}
                        variant="outlined"
                        onChange={event => changesEndereco(services.mask.cep(event.target.value), 'cep')}
                        value={services.mask.cep(centroDistribuicaoSeller?.endereco?.cep) || ''}
                    /* helperText={isFormInvalid && !centroDistribuicaoSeller?.endereco.cep && 'Campo obrigatório'}
                    error={isFormInvalid && !centroDistribuicaoSeller?.endereco.cep ? true : false} */
                    />
                </FormControl></div>
                <div className="col-sm-5 col-md-5 col-lg-5"><FormControl >
                    <TextField
                        /*   required */
                        label="Logradouro"
                        inputProps={{ maxLength: 150 }}
                        placeholder="Informe o endereço"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={event => changesEndereco(event.target.value, 'logradouro')}
                        value={centroDistribuicaoSeller?.endereco?.logradouro || ''}
                    /* helperText={isFormInvalid && !centroDistribuicaoSeller?.endereco.logradouro && 'Campo obrigatório'}
                    error={isFormInvalid && !centroDistribuicaoSeller?.endereco.logradouro ? true : false} */
                    />
                </FormControl></div>
                <div className="col-sm-2 col-md-2 col-lg-2"><FormControl >
                    <TextField
                        /*    required */
                        label="Número"
                        inputProps={{ maxLength: 10 }}
                        placeholder="000000"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={event => changesEndereco(event.target.value, 'numero')}
                        value={centroDistribuicaoSeller?.endereco?.numero || ''}
                    /* helperText={isFormInvalid && !centroDistribuicaoSeller?.endereco.numero && 'Campo obrigatório'}
                    error={isFormInvalid && !centroDistribuicaoSeller?.endereco.numero ? true : false} */
                    />
                </FormControl></div>
            </div>

            <div className="row">

                <div className="col-sm-4 col-md-4 col-lg-4"><FormControl >
                    <TextField
                        label="Complemento"
                        inputProps={{ maxLength: 250 }}
                        placeholder="Informe o complemento"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={event => changesEndereco(event.target.value, 'complemento')}
                        value={centroDistribuicaoSeller?.endereco?.complemento || ''}
                    />
                </FormControl></div>
                <div className="col-sm-2 col-md-2 col-lg-2"> <FormControl >
                    <TextField
                        /*   required */
                        label="Bairro"
                        placeholder="Informe o Bairro"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={event => changesEndereco(event.target.value, 'bairro')}
                        value={centroDistribuicaoSeller?.endereco?.bairro || ''}
                    /*  helperText={isFormInvalid && !centroDistribuicaoSeller?.endereco.bairro && 'Campo obrigatório'}
                     error={isFormInvalid && !centroDistribuicaoSeller?.endereco.bairro ? true : false} */
                    />
                </FormControl></div>
                <div className="col-sm-2 col-md-2 col-lg-2">
                    <FormControl>

                        <InputLabel id="demo-simple-select-helper-label">Estado</InputLabel>
                        <Select
                            /*   required */
                            className="select"
                            variant="outlined"
                            value={centroDistribuicaoSeller?.endereco?.estado || 'selecione'}
                            label="Estado"
                            onChange={event => changesEndereco(event.target.value, 'estado')}
                            MenuProps={MenuProps}
                        >
                            <MenuItem disabled={true} value={"selecione"}>
                                <em>Selecione o estado</em>
                            </MenuItem>

                            {estados.map(es =>
                                <MenuItem value={es}>{es}</MenuItem>
                            )}
                        </Select>

                        {/*   {isFormInvalid && !centroDistribuicaoSeller?.endereco?.estado &&
                            <FormHelperText>Campo obrigatório</FormHelperText>
                        } */}
                    </FormControl>
                </div>
                <div className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                        <InputLabel id="demo-simple-select-helper-label">Cidade</InputLabel>
                        <Select
                            /*   required */
                            className="select"
                            variant="outlined"
                            value={centroDistribuicaoSeller?.endereco?.cidade.toUpperCase() || 'cidade'}
                            label="Cidade"
                            onChange={event => changesEndereco(event.target.value, 'cidade')}
                            MenuProps={MenuProps}
                        >
                            <MenuItem disabled={true} value={"cidade"}>
                                <em>Selecione sua cidade</em>
                            </MenuItem>

                            {cidades.map(cd =>
                                <MenuItem value={cd.nome.toUpperCase()}>{cd?.nome}</MenuItem>
                            )}


                        </Select>
                        {/*   {isFormInvalid && !centroDistribuicaoSeller?.endereco?.cidade &&
                            <FormHelperText>Campo obrigatório</FormHelperText>
                        } */}
                    </FormControl>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12 col-md-9 col-lg-9">
                    <FormControl>
                        <TextField
                            label="URL Google Maps"
                            placeholder="Informe a URL"
                            type="text"
                            size="small"
                            inputProps={{ maxLength: 500 }}
                            id="outlined-basic"
                            variant="outlined"
                            onChange={event => changesEndereco(event.target.value, 'urlGoogleMaps')}
                            value={centroDistribuicaoSeller?.endereco?.urlGoogleMaps || ''}
                        /*  helperText={isFormInvalid && !centroDistribuicaoSeller?.endereco.urlGoogleMaps && 'Campo obrigatório'}
                         error={isFormInvalid && !centroDistribuicaoSeller?.endereco.urlGoogleMaps ? true : false} */
                        />
                    </FormControl></div>
                <div className="col-sm-12 col-md-3 col-lg-3">
                    <FormControl>

                        <InputLabel id="demo-simple-select-helper-label">Tipo*</InputLabel>
                        <Select
                            required
                            className="select"
                            variant="outlined"
                            value={centroDistribuicaoSeller?.tipoUnidade ?? 4}
                            label="Tipo"
                            onChange={event => changesTipoUnidade(event.target.value, 'tipoUnidade')}
                            MenuProps={MenuProps}
                        >
                            <MenuItem disabled={true} value={4}>
                                <em>Selecione o tipo</em>
                            </MenuItem>

                            {tiposUnidades.map(un =>
                                <MenuItem value={un.value}>{un.label}</MenuItem>
                            )}
                        </Select>

                        {isFormInvalid && (centroDistribuicaoSeller?.tipoUnidade == null || centroDistribuicaoSeller?.tipoUnidade == 4 || centroDistribuicaoSeller?.tipoUnidade == undefined) &&
                            <FormHelperText>Campo obrigatório</FormHelperText>
                        }
                    </FormControl>
                </div>
            </div>
            <div className="row"> <div className="col-sm-12 col-md-12 col-lg-12 font"><strong>Carga Descarga</strong></div></div>

            <div className="row mt-3">
                <div className="col-sm-4 col-md-4 col-lg-4">
                    <TextField
                        label="Horário de atendimento"
                        placeholder="Informe o horário de atendimento"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={event => changesAtendimentoCargaDescarga(event.target.value, 'horarioAtendimento')}
                        value={centroDistribuicaoSeller?.atendimentoCargaDescarga?.horarioAtendimento}
                    />
                </div>
                <div className="col-sm-4 col-md-4 col-lg-4">
                    <TextField
                        label="Contato"
                        placeholder="Informe o contato"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={event => changesAtendimentoCargaDescarga(event.target.value, 'contato')}
                        value={centroDistribuicaoSeller?.atendimentoCargaDescarga?.contato}
                    />
                </div>
                <div className="col-sm-4 col-md-4 col-lg-4">
                    <TextField
                        label="Observações adicionais"
                        placeholder="Informe as observações adicionais"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={event => changesAtendimentoCargaDescarga(event.target.value, 'observacoes')}
                        value={centroDistribuicaoSeller?.atendimentoCargaDescarga?.observacoes}
                    />
                </div>
            </div>


            {/*  <div className="col-sm-12 col-md-12 col-lg-12 mt-5 flex flex-end buttons">
                <button className="col-sm-6 col-md-6 col-lg-6 buton-green" onClick={submitcentroDistribuicaoSeller}>SALVAR</button>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-white-black-border" onClick={() => voltar(2)}>CANCELAR</button>
                <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border " onClick={inativarcentroDistribuicaoSeller}>INATIVAR</button>
            </div>
 */}
            {idCdSeller &&
                <div className="mt-5">
                    <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                        <button className="col-sm-6 col-md-6 col-lg-6 buton-green" onClick={() => submitcentroDistribuicaoSeller()}>SALVAR</button>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                        <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-white-black-border" onClick={() => voltar(2)}>CANCELAR</button>
                        {centroDistribuicaoSeller?.ativo && <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border" onClick={inativarCentroDistribuicao} >INATIVAR</button>}
                        {!centroDistribuicaoSeller?.ativo && <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border" onClick={ativarCentroDistribuicao}>ATIVAR</button>}

                    </div>


                </div>}

            {idCdSeller == null &&
                <div className="mt-5">
                    <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                        <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-white-black-border" onClick={() => voltar(2)}>CANCELAR</button>
                        <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-green" onClick={submitcentroDistribuicaoSeller}>SALVAR</button>
                    </div>

                </div>}
        </div>
    )
}

export default FormCdSeller;